import gsap from 'gsap';

const magazineHeaderHamburger = () => {
    const hamburger = document.querySelector('.jsMagazineHeaderHamburger');

    if(!hamburger) return;

    const drawer = document.querySelector('.jsMagazineHeaderdrawer');
    // ハンバーガーアイコンのバーの要素を上から取得
    const iconTop = hamburger.querySelector('span:nth-child(1)');
    const iconMiddle = hamburger.querySelector('span:nth-child(2)');
    const iconBottom = hamburger.querySelector('span:nth-child(3)');
    // タイムラインの初期状態を設定
    const timeLine = gsap.timeline({reversed: true});

    // 各要素の初期状態を設定
    gsap.set(drawer, {
        autoAlpha: 0,
        display: 'none'
    });
    gsap.set(iconTop, {
        top: '25%',
    });
    gsap.set(iconMiddle, {
        top: '50%',
    });
    gsap.set(iconBottom, {
        top: '75%',
    });

    timeLine
        .to(iconTop, {
            top: '50%',
            duration: 0.3
        }, 'toMiddleTranslate') // 同じラベルを同時起動させる
        .to(iconBottom, {
            top: '50%',
            duration: 0.3
        }, 'toMiddleTranslate')
        .to(iconMiddle, {
            opacity: 0,
            duration: 0.3
        }, 'toMiddleTranslate')
        .to(iconTop, {
            rotation: '45deg',
            duration: 0.2
        }, 'rotate45')
        .to(iconBottom, {
            rotation: '-45deg',
            duration: 0.2
        }, 'rotate45')
        .to(drawer, {
            autoAlpha: 1,
            display: 'block',
            duration: 0.5
        }, '-=0.5'); // 0.5s早く起動させる

    hamburger.addEventListener('click', () => {
        if (timeLine.reversed()) {
            timeLine.play();
        } else {
            timeLine.reverse();
        }
    });
}
export { magazineHeaderHamburger };